// extracted by mini-css-extract-plugin
module.exports = {"navItem":"nav-item-module__navItem___1bX7x","navText":"nav-item-module__navText___3D-6B"};